import "./brands-banner.scss";
import { debounce } from "lodash";

if (!window.dAgency) window.dAgency = {};
window.dAgency.initBrandsBanner = (context) => {
  const brandsSection = context.closest(".shopify-section");
  if (!brandsSection) return;

  const allBrandsButton = brandsSection.querySelectorAll(".brand-item");
  if (!allBrandsButton) {
    return;
  } else {
    tippy(allBrandsButton, {
      content: (reference) => reference?.nextSibling ?? "",
      maxWidth: 300,
      placement: "right-start",
      animation: "fade",
      theme: "white",
      arrow: false,
      interactive: true,
      offset: [0, 70],
      appendTo: () => document.body,
      sticky: true,
    });
  }

  const calcHeight = (wrapper) => {
    wrapper.style.height = "";
    var height = parseInt(getComputedStyle(wrapper).height.replace("px", ""));
    while (wrapper.scrollWidth > window.innerWidth) {
      height += 100;
      wrapper.style.height = `${height}px`;
    }
  };

  const debounceCalcHeight = debounce(() => {
    brandsSection
      .querySelectorAll(".brands-banner__list__group__letters")
      .forEach((categoryWrapper) => {
        calcHeight(categoryWrapper);
      });
  });
  ["resize", "orientationchange"].forEach((evt) =>
    window.addEventListener(evt, debounceCalcHeight)
  );

  debounceCalcHeight();
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll(".brands-banner"), (el) => {
    window.dAgency.initBrandsBanner(el);
  });
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(document.querySelectorAll(".brands-banner"), (el) => {
      window.dAgency.initBrandsBanner(el);
    });
  });
}
